import { CSSProperties } from "react";
import I18n from "common/i18n";
import { getPlanColor } from "common/elements";
import { PlanType } from "features/subscription";

type Props = {
  plan: PlanType;
};

export const UserPlanInactiveNotice = ({ plan }: Props) => {
  const accent = getPlanColor(plan);

  return (
    <div
      className="flex-row-el shrink-0 items-center gap-3 rounded-2xl bg-white px-4 py-3 border-2 border-solid border-[color:var(--plan-accent)]"
      style={{ "--plan-accent": accent } as CSSProperties}
    >
      <span className="material-symbols-outlined type-title shrink-0 text-[color:var(--plan-accent)]">
        verified
      </span>
      <p className="flex-1 type-text type-body leading-tight text-[color:var(--plan-accent)]">
        {I18n.t("MSG_USER_PLAN_INACTIVE_NOTICE")}
      </p>
    </div>
  );
};
